import React from "react";
import { Link } from "react-router-dom";

function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2 leading-none">
      <span className="text-3xl font-['Pacifico'] text-white">elektra</span>
      <span className="text-xl font-['Pacifico'] text-white/90">aanleggen</span>
    </Link>
  );
}

export default Logo;
